import apiRequest from "./apiRequest";

export const getBookings = async (query, token) => {
  const bookings = await apiRequest.get(`v2/sensors/em/bookings?${query}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return bookings.data;
};
